module.exports = __webpack_public_path__ + "static/img/tab2.00b8b6b6.png";